import { useQuery } from '@tanstack/react-query'
import { ExtendableQueryOptions } from 'shared/api/api.types'

import { authApi } from '../..'
import { GetDemoOrgIdsResponse } from './demoOrgIds.types'

export const getDemoOrgIds = async () => {
  const response = await authApi.get<GetDemoOrgIdsResponse>('/demo_org_ids')
  return response.data.data
}

export const GET_DEMO_ORG_IDS_QUERY_KEY = 'getDemoOrgIds'

export const useGetDemoOrgIdsQuery = (
  options?: ExtendableQueryOptions<GetDemoOrgIdsResponse['data']>
) => {
  return useQuery({
    queryKey: [GET_DEMO_ORG_IDS_QUERY_KEY],
    queryFn: getDemoOrgIds,
    ...options
  })
}
